<script>
  import { getZIndex } from '@/scripts/helpers/utils';

  export default {
    props: {
      active: {
        type: Boolean,
        default: true,
      },
      stackClass: {
        type: String,
        default: '__stackable',
      },
      stackMinZIndex: {
        type: Number,
        default: 1000,
      },
    },
    data() {
      return {
        zIndex: 1000,
      };
    },
    watch: {
      zIndex(val, oldVal) {
        if (val === oldVal) return;

        this.$emit('stacked', val);
      },
    },
    mounted() {
      if (typeof window === 'undefined') return;

      if (!this.$el) return;

      const index = !this.active
        ? getZIndex(this.$el)
        : this.getMaxZIndex([this.$el]) + 2;

      if (index === null) return;

      this.zIndex = parseInt(index, 10);
    },
    methods: {
      getMaxZIndex(exclude = []) {
        const zis = [this.stackMinZIndex, getZIndex(this.$el)];
        const stackedElements = [...document.getElementsByClassName(this.stackClass)];

        stackedElements.forEach((element) => {
          if (!exclude.includes(element)) {
            zis.push(getZIndex(element));
          }
        });

        return Math.max(...zis);
      },
    },
  };
</script>

<template>
  <div
    :class="stackClass"
    :style="{ zIndex }"
  >
    <slot />
  </div>
</template>
